import styled from "styled-components";

import { BaseButton } from "@shared/styles/common.styled";

export const ButtonContainer = styled.div`
  display: flex;
  align-items: center;
`;

export const SelectButton = styled(BaseButton)`
  background: #ffbb34;
  border: 1px solid #ffbb34;
`;

export const ValidateButton = styled(BaseButton)`
  background: #ff5101;
  border: 1px solid #ff5101;
`;

export const DisabledButton = styled(BaseButton)`
  background: slategray;
  border: 1px solid slategray;
`;

export const EditButton = styled(BaseButton)`
  background-color: transparent;
  border: none;
  padding: 7px;
  min-width: auto;
  flex: 1;
  margin: 0 0 0 8px;
`;

export const FlexRow = styled.div`
  display: flex;
  align-items: ${(props) => props.align ?? "center"};
  > div {
    margin-right: 1rem;
  }
`;
